import React from 'react';
import { Leaf, Clock, Award, Sparkles } from 'lucide-react';
import { FEATURES } from '../mock';
import Reveal from './Reveal';

const ICONS = [Leaf, Clock, Award, Sparkles];

export default function About() {
  return (
    <section id="about" className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          {/* Image */}
          <Reveal>
            <div className="relative">
              <div className="rounded-[28px] overflow-hidden shadow-2xl aspect-[5/4]">
                <img
                  src="https://images.unsplash.com/photo-1531058240690-006c446962d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxmbG93ZXIlMjBzaG9wfGVufDB8fHx8MTc4NjE1MzM4N3ww&ixlib=rb-4.1.0&q=85"
                  alt="Our florist studio"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -right-4 sm:-right-6 bg-[#3D5142] text-white rounded-2xl px-7 py-5 shadow-xl">
                <span className="block font-serif-display text-[38px] leading-none">30+</span>
                <span className="block text-[13px] tracking-wide text-[#D9C9Bf] mt-1">Years of blooms</span>
              </div>
            </div>
          </Reveal>

          {/* Copy */}
          <div>
            <Reveal>
              <span className="text-[13px] tracking-[0.3em] uppercase text-[#C4715A] font-medium">Why Choose Us</span>
              <h2 className="font-serif-display text-[36px] sm:text-[46px] text-[#26302a] mt-3 leading-tight">A real local florist who cares about every petal</h2>
              <p className="mt-5 text-[16px] leading-relaxed text-[#5A554C]">
                We are a family-run florist proudly serving Redwood City, Menlo Park and the greater Bay Area. What sets us apart is the care in every detail — fresh, quality blooms, thoughtful design, and a wide selection for every occasion.
              </p>
            </Reveal>

            <div className="grid sm:grid-cols-2 gap-x-8 gap-y-7 mt-10">
              {FEATURES.map((f, i) => {
                const Icon = ICONS[i];
                return (
                  <Reveal key={f.title} delay={i * 80}>
                    <div className="flex gap-4">
                      <span className="shrink-0 w-11 h-11 rounded-xl bg-[#EDE7DC] flex items-center justify-center">
                        <Icon className="w-5 h-5 text-[#3D5142]" />
                      </span>
                      <div>
                        <h3 className="font-serif-display text-[19px] text-[#2A2A28]">{f.title}</h3>
                        <p className="text-[14px] text-[#6A655C] mt-1 leading-relaxed">{f.desc}</p>
                      </div>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
